import { forwardRef } from 'react'
import { useParams } from 'react-router-dom'
import MarginInfo from '@/components/trade/MarginInfo'
import OrderForm from '@/components/trade/OrderForm'
import { ORDER_SIDE } from '@/constants/order'
import './OrderFormPanel.css'

export default forwardRef(function OrderFormPanel({ children, ...props }, ref) {
  props = {
    ref,
    ...props,
    className: `${props.className} card noselect order-form-panel`
  }
  const { marketSymbol = '' } = useParams()
  const [marketType] = marketSymbol.split('_')
  const isFutures = marketType === 'PERP'

  return (
    <div {...props}>
      <div className="card-draggable-area" />
      {isFutures ? (
        <>
          <MarginInfo />
          <div className="order-form-container">
            <OrderForm
              id="futuresBuy"
              orderSide={ORDER_SIDE.buy}
              showBalance={false}
              showHiddenOrderOption={false}
            />
            <OrderForm
              id="futuresSell"
              orderSide={ORDER_SIDE.sell}
              showBalance={false}
              showOrderTypeSwitcher={false}
              showOrderTypeOption={false}
            />
          </div>
        </>
      ) : (
        <OrderForm id="spot" />
      )}
      {children}
    </div>
  )
})
